import { render, staticRenderFns } from "./compRegMobile.vue?vue&type=template&id=7bc22a62&scoped=true"
import script from "./compRegMobile.vue?vue&type=script&lang=js"
export * from "./compRegMobile.vue?vue&type=script&lang=js"
import style0 from "./compRegMobile.vue?vue&type=style&index=0&id=7bc22a62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc22a62",
  null
  
)

export default component.exports